import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_dialog = _resolveComponent("p-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.tutorial_on)
        ? (_openBlock(), _createBlock(_component_p_button, {
            key: 0,
            class: "p-button-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = true)),
            icon: "pi pi-book",
            "aria-label": "Guide",
            title: "Guide me"
          }))
        : _createCommentVNode("", true),
      (_ctx.tutorial_on)
        ? (_openBlock(), _createBlock(_component_p_button, {
            key: 1,
            class: "p-button-lg exit-button",
            onClick: _ctx.exitTutorial,
            icon: "pi pi-sign-out",
            label: "Exit Tutorial",
            "aria-label": "Guide",
            title: "Guide me"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_p_dialog, {
      visible: _ctx.dialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
      modal: "",
      position: "bottomleft",
      header: "Tutorials",
      style: { width: '700px' }
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"height":"400px"} }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", { href: "/masters?tutorial=create_email" }, "Sending and Tracking Messages")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", { href: "/masters?tutorial=business_rule" }, "Route responses with Business Rules")
            ])
          ])
        ], -1)
      ]))]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}